import React, { useState } from 'react';
import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { BACKEND_URL_PORTAIL } from "../../../config/const.js";
import { useTranslation } from 'react-i18next';
import './Styles.css';

const MultiDeleteDialog = ({ isOpen, handleClose, listUsers, fetchUserProfile }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState(null);

  const handleDeleteGroup = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const data = {
      listIds: listUsers,
      currentOrg: localStorage.getItem("currentOrg"),
    };

    try {
      await axios.post(`${BACKEND_URL_PORTAIL}api/deleteUsers`, data, config);
      setMessage({ type: 'success', text: t('successDeleteGroup') });
      setTimeout(() => {
        fetchUserProfile();
        setMessage(null);
        handleClose();
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('Error deleting users:', error);
      setMessage({ type: 'error', text: t('failureDeleteGroup') });
      setTimeout(() => {
        setMessage(null);
      }, 2000);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={handleClose} centered>
        {listUsers.length === 0 ? (
          <>
            
            <ModalBody className="text-center">
              <div className="fileDesc mb-3">
                <div className="d-flex justify-content-center align-items-center">
                  <i className="mdi mdi-alert-circle mdi-48px text-danger"></i>
                </div>
              </div>
              <p className="alertMsg">{t('NoUserSelected')}</p>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
              <button className="btn btn-primary" onClick={handleClose}>
                {t('ok')}
              </button>
            </ModalFooter>
          </>
        ) : (
          <>
            <ModalHeader toggle={handleClose}>{t('deleteUser')}</ModalHeader>
            <ModalBody>
              <p>{t('messageDeleteUsers')}</p>
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-secondary" onClick={handleClose}>
                {t('cancel')}
              </button>
              <button className="btn btn-danger" onClick={handleDeleteGroup}>
                {t('delete')}
              </button>
            </ModalFooter>
          </>
        )}
      </Modal>

      {/* Message de succès ou d'erreur */}
      {message && (
        <div
          style={{
            position: 'fixed',
            bottom: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '10px 20px',
            backgroundColor: message.type === 'success' ? 'green' : '#ff3d60',
            color: 'white',
            borderRadius: '5px',
            zIndex: 1000,
            minWidth: "25%",
            textAlign: 'center',
            transition: 'opacity 0.5s ease-in-out',
          }}
        >
          {message.text}
        </div>
      )}
    </>
  );
};

export default MultiDeleteDialog;
